// React

// Utils
import TEXT from "../../../utils/globalText";
import Validation from "../../../utils/validation";

// Components
import AmountToWords from "../../_utils/AmountToWords";
import CommonLayout from "../../_utils/CommonLayout";
import Amount from "../../_utils/TransactionCommonComponents/Amount";

import "./index.css";

const ReimbursementRequestTxnTransferAmount = ({
  txnPayLoad,
  setTxnPayLoad,
  amountInWords,
  setAmountInWords,
  copyData,
  setCopyData,
}) => {
  // Callbacks
  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };
  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      setTxnPayLoad((prev) => ({
        ...prev,
        amount: "",
        amountInWords: "",
      }));
      setAmountInWords("");
      return;
    }

    if (trimmedValue[0] === "0") return;

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");

    if (
      name === "amount" &&
      (allowedValue(numericValue) || !numericValue.length)
    ) {
      const amountNumber = parseFloat(numericValue);
      const amountWords =
        numericValue.trim() === "" ? "" : AmountToWords(amountNumber);

      const adjustedAmountWords =
        amountNumber > 0 && amountNumber <= 1
          ? amountWords.replace("rupees", "rupee")
          : amountWords;

      setAmountInWords(adjustedAmountWords);
      setTxnPayLoad((prev) => ({
        ...prev,
        amount: numericValue,
        amountInWords: adjustedAmountWords,
      }));
    }
  };

  return (
    <>
      <div
        className="w-width-full h-height-full items-start px-padding-md Qlg:px-padding-base overflow-y-auto  Qsmd:pt-padding-lg pt-padding-md"
        style={{ scrollbarWidth: "none" }}
      >
        <CommonLayout>
          <Amount
            title={TEXT?.TRANSFER_AMOUNT}
            amount={txnPayLoad?.amount}
            amountInWords={amountInWords}
            copyData={copyData}
            onAmountChange={(val) =>
              handleAmountChange({ name: "amount", value: val })
            }
            onPasteApplied={() =>
              setCopyData({ title: "", data_type: "", value: "" })
            }
            isPreview={false}
          />
        </CommonLayout>
      </div>

      <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
    </>
  );
};

export default ReimbursementRequestTxnTransferAmount;
